import { toast } from "sonner";
import { Info } from "lucide-react";
import { useApi, useFetch, useMe, errMsg, fmtDate } from "../lib/api";
import { Btn, Card, PageHeader, StateBadge } from "../components/common";

export default function Integrations() {
  const api = useApi();
  const { isAdmin } = useMe();
  const { data, reload } = useFetch("/integrations");
  const test = async (k) => {
    try { const r = await api.post(`/integrations/${k}/test`); r.ok ? toast.success(r.message) : toast.error(r.message); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Integrations" subtitle="Status legend: tested ok · configured untested · awaiting credentials · test failed. Nothing is reported as working until a live test passes." />
      <Card className="mb-6" testid="email-finding">
        <div className="flex gap-3 text-sm text-slate-700"><Info size={18} className="mt-0.5 shrink-0 text-blue-600" />
          <div><b>Business email finding:</b> <span className="font-mono">contact@datameridianconsulting.com</span> is a Cloudflare Email Routing forward into your Gmail (no mailbox, no sending service for the domain). The website's enquiry and booking notifications arrive in the same Gmail and become CRM leads on every sync; the live site is untouched.
            Approved (or, if switched on in Settings, automatic) outreach is sent from your Gmail with Reply-To set to contact@, so client replies come back into this CRM.</div></div>
      </Card>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {(data || []).map((i) => (
          <Card key={i.key} testid={`integration-${i.key}`}>
            <div className="flex items-start justify-between gap-2"><h3 className="text-sm font-semibold">{i.name}</h3><StateBadge s={i.status} testid={`integration-status-${i.key}`} /></div>
            <p className="mt-2 text-xs text-slate-600">{i.detail}</p>
            {i.test && <p className={`mt-2 text-[11px] ${i.test.ok ? "text-emerald-700" : "text-red-600"}`}>Last test {fmtDate(i.test.at)}: {i.test.message}</p>}
            {i.status === "awaiting_credentials" && <p className="mt-2 text-[11px] text-slate-500">To add credentials securely, ask the assistant in chat to “add {i.required?.[0] || "keys"}” — you'll get a secure entry card.</p>}
            {isAdmin && i.key !== "auth" && i.status !== "awaiting_credentials" && i.status !== "not_configured" && <Btn variant="ghost" className="mt-3 h-8 text-xs" onClick={() => test(i.key)} data-testid={`integration-test-${i.key}`}>Run live test</Btn>}
          </Card>))}
      </div>
    </div>
  );
}
